import Vector3 from '../math/Vector3';

export default class TRIANGLE_normal {
	vertices: Vector3;
	normals: Vector3;

	constructor (pi: number, pj: number, pk: number, ni: number, nj: number, nk: number) {
		this.vertices = new Vector3(pi, pj, pk);
		this.normals = new Vector3(ni, nj, nk);
	}
}
